import { useMutation } from '@tanstack/react-query'

import { generateCustomBrief } from '../api'

const useGenerateCustomBriefMutation = () => {
  return useMutation({ mutationFn: generateCustomBrief })
}

export default useGenerateCustomBriefMutation
